import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { checkEmptyFields } from '../utils';
import { ProductType } from '@lentau/product/shared/interfaces';
import { ActionType } from '@lentau/core/application/shared';
import { PromotionsSearchResponseType } from '@lentau/promo/promo-detail-lnt/shared';

export function promoactionSearchHandler(data: PromotionsSearchResponseType): EventProperties {
  {
    const promoactionList: ActionType[] = data.PromoactionList || [];
    const goods: ProductType[] = data?.PromoactionGoodsItemList || [];

    const fields = [
      ...promoactionList
        .filter(Boolean)
        .map((action: ActionType) => {
          return [
            {
              fieldToCheck: action.Name,
              errorName: 'actionDetailNameIsEmpty',
            },
            {
              fieldToCheck: action.Description,
              errorName: 'actionDetailDescriptionIsEmpty',
            },
            {
              fieldToCheck: action.BannerImage,
              errorName: 'actionDetailPreviewImageIsEmpty',
            },
          ];
        })
        .flat(),
      {
        fieldToCheck: goods,
        errorName: 'actionDetailGoodsListIsEmpty',
      },

      ...goods
        .map((product: ProductType) => {
          return [
            {
              fieldToCheck: product.Id,
              errorName: 'actionDetailProductIdIsEmpty',
            },
            {
              fieldToCheck: product.Name,
              errorName: 'actionDetailProductNameIsEmpty',
            },
            {
              fieldToCheck: product.Images,
              errorName: 'actionDetailProductImagesIsEmpty',
            },
          ];
        })
        .flat(),
    ];

    return checkEmptyFields(fields);
  }
}
